import {toast} from 'react-toastify';

let initialState = {
	infos: [],
	one: [],
	create: [],
	update: [],
	delete: []
};

const getUsersInfos = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_USERS_RETURN':
			return Object.assign({}, state, {infos: action.payload});

		case 'PUT_USER_RETURN':
			let array = [];
			let newStateUpdate;
			if (action.payload.status === 202) {
				array = state.infos.data.items.map((item) => {
					return item.uuid === action.payload.data.uuid ? action.payload.data : item;
				});

				let variable = {...state.infos.data, items: array};
				newStateUpdate = {...state.infos, data: variable};

				const notifySuccess = () =>
					toast.success('Utilisateur mis à jour !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				newStateUpdate = state.infos;
				const notifyError = () =>
					toast.error('Erreur ! merci de le signaler...', {
						position: 'top-right',
						autoClose: 3000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifyError();
			}
			return Object.assign({}, state, {
				update: action.payload,
				infos: newStateUpdate
			});

		case 'DELETE_USER_RETURN':
			if (action.payload.status === 200 || action.payload.status === 204) {
				const filteredItems = state.infos.data.items.filter(
					(item) => item.uuid !== action.payload.data?.uuid
				);
				const variable = {...state.infos.data, items: filteredItems};
				const newStateDelete = {...state.infos, data: variable};

				toast.success('Utilisateur supprimé !', {
					position: 'top-right',
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined
				});
				return Object.assign({}, state, {
					delete: action.payload,
					infos: newStateDelete
				});
			} else {
				toast.error('Erreur lors de la suppression !', {
					position: 'top-right',
					autoClose: 3000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined
				});
				return state;
			}

		default:
			return state;
	}
};

export default getUsersInfos;
